<template>
  <div class="container mt-4">
    <!-- Report Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">Talent Users Report</h2>
      <button class="btn btn-danger" @click="exportPDF">Export PDF</button>
    </div>

    <!-- Summary Card -->
    <div class="card shadow-sm mb-4">
      <div class="card-body d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Total Talents</h5>
        <span class="badge bg-primary fs-5">{{ users.length }}</span>
      </div>
    </div>

    <!-- Users Table -->
    <div class="table-responsive shadow-sm">
      <table class="table table-striped align-middle" style="border-collapse: collapse; border: none;">
        <thead class="table-dark">
          <tr>
            <th style="border: none;">#</th>
            <th style="border: none;">Title</th>
            <th style="border: none;">Institute</th>
            <th style="border: none;">Qualification</th>
            <th style="border: none;">Status</th>
            <th style="border: none;">DOB</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="user.id">
            <td style="border: none;">{{ index + 1 }}</td>
            <td style="border: none;">{{ user.title || "N/A" }}</td>
            <td style="border: none;">{{ user.institute || "N/A" }}</td>
            <td style="border: none;">{{ user.qualification || "N/A" }}</td>
            <td style="border: none;">
              <span :class="badgeClass(user.status)">
                {{ user.status || "unknown" }}
              </span>
            </td>
            <td style="border: none;">{{ formatDate(user.dob) }}</td>
          </tr>
          <tr v-if="users.length === 0">
            <td colspan="7" class="text-center" style="border: none;">No data available</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  name: "TalentUsersReport",
  data() {
    return {
      users: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    badgeClass(status) {
      return status === "active"
        ? "badge bg-success"
        : "badge bg-danger";
    },
    formatDate(iso) {
      if (!iso) return "-";
      const d = new Date(iso);
      return d.toLocaleDateString();
    },
    async fetchTalents() {
      this.loading = true;
      this.error = null;
      try {
        const res = await axios.get(
          "https://geotalent-backend-production.up.railway.app/api/Appointments/LoadProfiles?role=talent",
          {
            headers: { Authorization: "Bearer " + this.$store.state.userData.token },
          }
        );
        if (res.data && res.data.status === "success") {
          this.users = res.data.data || [];
        } else {
          this.error = "API returned unsuccessful status.";
        }
      } catch (e) {
        this.error = e.message || "Failed to load data.";
      } finally {
        this.loading = false;
      }
    },
    exportPDF() {
      try {
        const doc = new jsPDF();
        doc.setFontSize(16);
        doc.text("Talent Users Report", 14, 20);

        const rows = this.users.map((u, i) => [
          i + 1,
          u.title || "-",
          u.institute || "-",
          u.qualification || "-",
          u.status || "-",
          this.formatDate(u.dob),
        ]);

        doc.autoTable({
          head: [["#", "Title", "Institute", "Qualification", "Status", "DOB"]],
          body: rows,
          startY: 30,
          styles: { fontSize: 9 },
          headStyles: { fillColor: [33, 37, 41] },
        });

        doc.save("talent_users_report.pdf");
      } catch (err) {
        alert("PDF Export Failed: " + err.message);
        console.error(err);
      }
    },
  },
  mounted() {
    this.fetchTalents();
  },
};
</script>

<style scoped>
/* Force header background and text color */
.table thead.table-dark th {
  background-color: #343a40 !important; /* dark gray */
  color: #fff !important; /* white text */
}

/* Dark mode tweak */
@media (prefers-color-scheme: dark) {
  .table thead.table-dark th {
    background-color: #1c1c1c !important;
    color: #fff !important;
  }
}
</style>
